import { render, staticRenderFns } from "./artist-search.vue?vue&type=template&id=012c47d6"
import script from "./artist-search.vue?vue&type=script&lang=js"
export * from "./artist-search.vue?vue&type=script&lang=js"
import style0 from "./artist-search.vue?vue&type=style&index=0&id=012c47d6&prod&lang=scss"
import style1 from "./artist-search.vue?vue&type=style&index=1&id=012c47d6&prod&media=screen&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./artist-search.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports